import React from "react";
import ReactDOM from "react-dom/client";
import { HashRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { initializeIcons } from "@fluentui/react";

import "./index.css";

import Layout from "./pages/layout/Layout";
import NoPage from "./pages/NoPage";
import OneShot from "./pages/oneshot/OneShot";
import Chat from "./pages/chat/Chat";
import Login from "./pages/login/LoginPage";
import InvalidToken from "./pages/InvalidToken";
import { AuthProvider, useAuth } from "./contexts/useAuth";
import { UserProvider } from "./contexts/useUserData";
import { LayoutProvider } from "./contexts/useLayoutContext";
import { ChatProvider } from "./contexts/useChatData";
import { FeatureFlagsProvider } from "./contexts/useFeatureFlags";

initializeIcons();

interface Props {
    children?: JSX.Element;
    // any props that come into the component
}
export default function App() {
    const ProtectedRoute = ({ children }: Props) => {
        const { isAuthenticated, isErrorTokenLogin } = useAuth();

        console.log("Params: ", window.location.search);
        const params = {
            token: new URLSearchParams(window.location.search).get("token")
        };

        if (isErrorTokenLogin) {
            return <Navigate to="/errorToken" />;
        } else if (!isAuthenticated) {
            console.log("NO AUTENTICADO");
            if (params && params.token) {
                return <Navigate to={`/login?token=${params.token}`} />;
                // ${params.token}
            } else {
                return <Navigate to="/login" />;
            }
        } else {
            console.log("AUTENTICADO");
            return children!;
        }
    };

    return (
        <AuthProvider>
            <UserProvider>
                <ChatProvider>
                    <LayoutProvider>
                        <FeatureFlagsProvider>
                        <HashRouter>
                            <Routes>
                                <Route path="/login" element={<Login />} />
                                <Route
                                    path="/"
                                    element={
                                        <ProtectedRoute>
                                            <Layout />
                                        </ProtectedRoute>
                                    }
                                >
                                    <Route
                                        path="chat"
                                        element={
                                            <ProtectedRoute>
                                                <Chat />
                                            </ProtectedRoute>
                                        }
                                    />
                                    <Route
                                        path="qa"
                                        element={
                                            <ProtectedRoute>
                                                <OneShot />
                                            </ProtectedRoute>
                                        }
                                    />
                                    <Route path="*" element={<NoPage />} />
                                </Route>
                                <Route path="/errorToken" element={<InvalidToken />} />
                            </Routes>
                        </HashRouter>
                        </FeatureFlagsProvider>
                    </LayoutProvider>
                </ChatProvider>
            </UserProvider>
        </AuthProvider>
    );
}

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);
